import { render, staticRenderFns } from "./TrademarkTypeForm.vue?vue&type=template&id=2d7aad28&"
import script from "./TrademarkTypeForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkTypeForm.vue?vue&type=style&index=0&id=2d7aad28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports